import { cn } from "@/lib/utils";
import { Loader2 } from "lucide-react";

/**
 * Bare spinner. Inherits the parent's text color via `currentColor`
 * so callers control the contrast through the surrounding wrapper —
 * shell-level usages get the white shell-foreground via PageSpinner,
 * while inline usages inside cards/buttons inherit whatever the
 * card/button ancestor sets.
 */
export function Spinner({ className }: { className?: string }) {
    return <Loader2 className={cn("h-5 w-5 animate-spin", className)} />;
}

/**
 * Full-page (or full-section) loading affordance.
 *
 * `surface` selects which background the spinner sits on so the
 * contrast is correct without callers having to remember:
 *   - "shell" (default) — the dark app shell behind every office
 *     page. Spinner picks up `text-shell-foreground/80`.
 *   - "card"  — the cream `bg-background` used by the customer
 *     portal and full-page field workflows. Spinner picks up the
 *     usual dark `text-foreground/80`.
 */
export function PageSpinner({
    surface = "shell",
    className,
}: {
    surface?: "shell" | "card";
    className?: string;
}) {
    return (
        <div
            className={cn(
                "flex items-center justify-center h-64",
                surface === "shell" ? "text-shell-foreground/80" : "text-foreground/80",
                className,
            )}
        >
            <Spinner className="h-8 w-8" />
        </div>
    );
}
